/*
 * Perso cart bridge (thème V1 Fluorescent).
 * Le thème V1 ajoute au panier en single-line via theme.js (minifié). Quand des
 * options de perso sont cochées, on doit ajouter la peluche ET ses produits
 * compagnons en une requête items[]. On intercepte donc le submit du formulaire
 * produit en PHASE CAPTURE (pour passer avant le handler theme.js), on préempte,
 * on POST le panier multi-lignes, puis on redirige vers la page panier.
 * Si aucune option n'est cochée : on ne fait rien → comportement natif inchangé.
 */
(function () {
  if (window.__persoCartBridge) return;
  window.__persoCartBridge = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  root = root.replace(/\/$/, '');
  var addUrl = root + '/cart/add.js';
  var cartUrl = root + '/cart';

  function setLoading(btn, on) {
    if (!btn) return;
    btn.classList.toggle('loading', on);
    if (on) btn.setAttribute('aria-disabled', 'true');
    else btn.removeAttribute('aria-disabled');
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || typeof form.matches !== 'function' || !form.matches('form[data-product-form]')) return;

      // Jamais le composant du tiroir panier (scope cart), qui vit sur la même page.
      var perso = form.querySelector('perso-options') || document.querySelector('perso-options[data-scope="fiche"]');
      if (!perso || typeof perso.hasSelection !== 'function' || !perso.hasSelection()) return; // passthrough natif

      // Une option est cochée → on prend la main sur l'ajout panier.
      e.preventDefault();
      e.stopImmediatePropagation();

      // validate() surligne les champs manquants et affiche l'alerte du bloc.
      // On amène en plus le client au premier champ vide : sur mobile le bloc de
      // perso est souvent hors écran au moment du clic, et un simple focus() ne
      // suffisait pas à rendre le refus compréhensible.
      var validation = perso.validate();
      if (!validation.ok) {
        var target = validation.firstInvalid;
        if (target) {
          var card = target.closest('[data-perso-option]') || target;
          if (card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          try {
            target.focus({ preventScroll: true });
          } catch (err) {
            target.focus();
          }
        }
        return;
      }

      var fd = new FormData(form);
      var groupId = 'perso-' + Date.now().toString(36) + '-' + Math.floor(Math.random() * 1e6).toString(36);
      var items = perso.getCompanionItems(groupId).concat([
        {
          id: fd.get('id'),
          quantity: parseInt(fd.get('quantity'), 10) || 1,
          properties: Object.assign({ _perso_group: groupId }, perso.getMainProperties()),
        },
      ]);

      var btn = form.querySelector('[data-add-to-cart]') || form.querySelector('[type="submit"]');
      setLoading(btn, true);

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            console.error('[perso] ajout panier refusé', res.data);
            setLoading(btn, false);
            window.alert((res.data && res.data.description) || "Ajout au panier impossible.");
            return;
          }
          window.location.href = cartUrl;
        })
        .catch(function (err) {
          console.error('[perso] erreur ajout panier', err);
          setLoading(btn, false);
        });
    },
    true // capture
  );
})();
